module.exports = __webpack_public_path__ + "static/media/48370719_2308777415864103_501127962234454016_o-thumb.aa48d49e.jpg";